import React, { useEffect, useState } from "react"
import "./css/winners.css"
import ReactModal from "react-modal"
import { getRanking } from "../services/user-api"
import Confetti from "react-confetti"
import { useTranslation } from "react-i18next"
import { service} from "../utils/constant"

ReactModal.setAppElement("#root")

const Winners = ({ isOpen, closeModal }) => {
  const { t } = useTranslation("global")
  const [users, setUsers] = useState([]);
  const [userRank, setUserRank] = useState([]);
  const [userId, setUserId] = useState([])
  const rewards=["25 000F","10 000F","75 00F","5 000F","2 500F","","","","",""];

  useEffect(() => {
    if(isOpen)
    {
      getRanking()
        .then((res) => {
          console.log(res)
          setUsers(res.data.data);
          setUserRank(res.data.userRank);
          setUserId(res.data.userId);
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [isOpen])

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = seconds % 60

    return `${hours < 10 ? "0" : ""}${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`
  }

  return (
    <>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        shouldFocusAfterRender={false}
        shouldReturnFocusAfterClose={false}
        contentLabel="Winners Dialog"
        overlayClassName="winner-dialog-overlay"
        className="winner_dialog"
        bodyOpenClassName="ReactModal__Body--open"
        style={{
          overlay: {
            zIndex: 10050,
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "12px",
          },
          content: {
            zIndex: 10051,
            position: "relative",
            top: "auto",
            left: "auto",
            right: "auto",
            bottom: "auto",
            transform: "none",
            margin: 0,
            padding: 0,
            border: "none",
            background: "transparent",
            overflow: "visible",
            width: "auto",
            height: "auto",
            maxWidth: "none",
            maxHeight: "none",
          },
        }}
      >
        <div className="winners_page">
          <section className="header_container">
            <div className="winners_confetti" aria-hidden="true">
              <Confetti
                width={320}
                height={90}
                numberOfPieces={80}
                recycle={false}
                colors={["#22c2d2", "#5ee0ed", "#7b2ff7", "#ffffff"]}
              />
            </div>
            <div className="title_box">
              <img src="/images/crown.png" alt="Crown" />
              <div className="title">{t("TopWinners5")}<div className="rank">{t("YourRank")} - {userRank}
              </div></div>
            </div>
            <button className="close_btn" onClick={closeModal}>
              <i className="fas fa-xmark"></i>
            </button>
          </section>
         
           <section className="table-container">
           <table className="table">
             <thead className="thead">
               <tr>
                 <th scope="col">{t("Player")}</th>
                 <th scope="col">{t("Rank")}</th>
                 <th scope="col">{t("Time Spent")}</th>
                 {service==="ogb" && <th scope="col">{t("Rewards")}</th>}
               </tr>
             </thead>
             <tbody>
               {users.length > 0 &&
                 users.map((user, index) => {
                   return (
                     <tr key={user.id}>
                       <td>
                         <div className="player_name">
                           {/*<img src="/images/profile.png" alt="profile" />*/}
                           {service==="ogb"?<div>{user.userName.replace("245x","")}</div>:<div>{user.userName}</div>}
                         </div>
                       </td>
                       <td>{index + 1}</td>
                       <td>{formatTime(user.sou)}</td>
                       {service==="ogb" && <td>{rewards[index]}</td>}
                     </tr>
                   )
                 })}
             </tbody>
           </table>
         </section>
        
        </div>
      </ReactModal>
    </>
  )
}

export default Winners
